import { render, staticRenderFns } from "./ArrowDown.vue?vue&type=template&id=5d92632e&"
import script from "./ArrowDown.vue?vue&type=script&lang=js&"
export * from "./ArrowDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports